import script from "./OtpTokenModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OtpTokenModal.vue?vue&type=script&setup=true&lang=js"

import "./OtpTokenModal.vue?vue&type=style&index=0&id=fecc9904&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fecc9904"]])

export default __exports__